import OutbrineBase from './OutbrineBase';
import OutbrineDashboard from './OutbrineDashboard.vue';

export { OutbrineBase, OutbrineDashboard };
